import React, {useEffect, useRef, useState} from 'react';
import Slider from "react-slick";
import "./onboard-power-saving-mode-introduction-style.scss";
import OnboardSelect from "../onboard-select-component/OnboardSelect";
import OnboardButton from "../onboard-button-component/OnboardButton";
import {listAndroid, listIOS, listMacOs, listWindows} from "../../../util/PowerSavingModeIntroduction";
import {ReactComponent as LogoLoading} from 'assets/images/loading-load-sv.svg';
import {useRecoilValue} from "recoil";
import {agentAtom} from "../../../store/AgentStore";
import {setSimulationNumber} from '../../../util/SimulationManager';
import {informationAtom} from '../../../store/InformationStore';

const PowerSavingModeIntroductionComponent = (props) => {

    const {visible, t, i18n, location} = props;
    const information = useRecoilValue(informationAtom);
    const simulationNumber = setSimulationNumber();
    const isSimulation = setSimulationNumber();
    const sliderRef = useRef();

    const [mVisible, setMVisible] = useState(visible);
    const [list, setList] = useState(listIOS);
    const [mValue, setMValue] = useState({value: 1, label: "iPhone"});
    const agent = useRecoilValue(agentAtom);
    const [visibleIUnderstand, setVisibleIUnderstand] = useState(true);

    useEffect(() => {
        if (location.pathname !== "/simulation") {
            selectDefaultDevice();
        }
        setMVisible(visible);
        if (visible) {
            simulationNumber(2, 2);
        }
        if (isSimulation) {
            setVisibleIUnderstand(false);
        }
    }, [visible])

    const selectDefaultDevice = () => {
        let os = agent?.os?.name?.toString().toLowerCase();
        if (os?.indexOf("ios") >= 0) {
            selectDevice({value: 1, label: "iPhone"});
        } else if (os?.indexOf("mac") >= 0) {
            selectDevice({value: 2, label: "Macbook"});
        } else if (os?.indexOf("android") >= 0) {
            selectDevice({value: 3, label: "Android"});
        } else if (os?.indexOf("windows") >= 0) {
            selectDevice({value: 4, label: "Windows"});
        }
    }

    const options = [
        {value: 1, label: "iPhone"},
        {value: 2, label: "Macbook"},
        {value: 3, label: "Android"},
        {value: 4, label: "Windows"}
    ];

    const selectDevice = (val) => {
        setMValue(val)
        if (val.value === 1) {
            setList(listIOS);
        } else if (val.value === 2) {
            setList(listMacOs);
        } else if (val.value === 3) {
            setList(listAndroid);
        } else if (val.value === 4) {
            setList(listWindows);
        }
        if (val.value === 2) {
            simulationNumber(5, 2);
            goToSlide(0);
        } else if (val.value === 3) {
            simulationNumber(6, 2);
            goToSlide(0);
        } else if (val.value === 4) {
            simulationNumber(7, 2);
            goToSlide(0);
        }
    }

    const goToSlide = (index) => {
        if (sliderRef.current) {
            sliderRef.current.slickGoTo(index);
        }
    };

    useEffect(() => {
        if (information.simulationNumber === 7 && information.simulationStep === 2) {
            setVisibleIUnderstand(true);
        }
    }, [information.simulationNumber]);

    const renderDataList = () => {
        return list.map((value, index) => {
            return (
                <div key={index} className="onboard-power-saving-slider-div">
                    <div className="onboard-power-saving-slider-element">
                        <img className="onboard-power-saving-slider-img" alt="reader-img" width={'100%'}
                             src={getImage(value)}/>
                        <p className="onboard-power-saving-slider-content">{t(value.content)}</p>
                    </div>
                    <LogoLoading className="onboard-power-saving-slider-loading"></LogoLoading>
                </div>
            );
        })
    }

    const getImage = (value) => {
        return /tr/.test(i18n.language.toLowerCase()) ? value.imageTr : value.image
    }

    let settings = {
        dots: true,
        infinite: true,
        speed: 100,
        arrows: (agent.device?.type !== 'mobile'),
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        adaptiveHeight: true,
        className: "slick-slide-height",
        beforeChange: (oldIndex, newIndex) => {
            if (mValue.value === 1) {
                if (oldIndex === 0 && newIndex === 1) {
                    simulationNumber(3, 2);
                } else if (oldIndex === 1 && newIndex === 2) {
                    simulationNumber(4, 2);
                }
            }
        }
    };

    return (
        mVisible && (<div>
            <div className="onboard-power-saving-dialog-opacity"></div>
            <div className="onboard-power-saving-dialog-root">
                <div className="onboard-power-saving-dialog-root-2 p-b-24">
                    <p className="onboard-power-saving-dialog-title">{t('home.please_select_device_using')}</p>
                    <OnboardSelect placeholder={t('home.device')}
                                   options={options}
                                   value={mValue}
                                   onChange={(e) => selectDevice(e)}/>
                    <p className="onboard-power-saving-dialog-info">{t('home.follow_steps_below_on_your_device')}</p>
                    <div className="onboard-power-saving-dialog-slide">
                        <Slider {...settings} ref={sliderRef}>
                            {renderDataList()}
                        </Slider>
                    </div>
                    {visibleIUnderstand && (
                        <OnboardButton label={t('home.got_it')} onClick={() => {
                            simulationNumber(1, 3);
                            setMVisible(false)
                        }}/>
                    )}
                </div>
            </div>
        </div>)
    )
};

export default PowerSavingModeIntroductionComponent;
